export default "__VITE_ASSET__N8YMELlW__"